// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
import $ from 'jquery'
import axios from "axios"

Vue.prototype.$axios = axios
/* eslint-disable no-new */
import global from '@/components/global'//引用文件
Vue.prototype.GLOBAL = global
import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';
NutUI.install(Vue);
import '../static/api.css'
import '../static/aui.css'
import '../static/portal.css'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import moment from 'moment'
Vue.prototype.$moment = moment;//赋值使用
Vue.filter('datefmt', function (input, fmtstring) {
  return moment(input).format(fmtstring)
})
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

new Vue({
  el: '#app',
  router,
  components: { App },
  render: h => h(App),
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js